export const getProductStatusLabel = (allCalculatedTags: Array<string> | undefined) => {
  const outOfStock = 'Out of stock';
  if (!allCalculatedTags) {
    return outOfStock;
  }

  if (allCalculatedTags.includes('Coming Soon')) return 'Coming soon';
  if (allCalculatedTags.includes('In Store Only')) return 'In-store only';
  return outOfStock;
};
